"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostProductSizeAdd = void 0;
const Base_1 = require("./Base");
exports.PostProductSizeAdd = {
    url: Base_1.URL_BASE + "/ProductSizeAdd",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostProductSizeAdd.js.map